// extracted by mini-css-extract-plugin
export default {"container":"riyi9OljEuFYRGiEcCQv","spin":"zCG54EaTGRs8UBkETZpw","storybookSpinner":"ZhmwuJZaRaXQ6v6VfIf2"};